import React from 'react';
import Box from 'components/elements/Box';
import Button from 'components/elements/button';
import { Message } from '../shared/styles';

const CreateJobView: React.FC<{ changeView: () => void }> = ({
  changeView,
}) => {
  return (
    <Box padding="0 2.5rem" display="flex" flexDirection="column">
      <Message>You don’t have any Data Export jobs</Message>

      <Button
        onClick={changeView}
        variant="primary"
        alignSelf="center"
        justifySelf="center"
        fontWeight="600"
        borderRadius="3px"
        height="28px"
        py={1}
        px={4}
        mt={3}
        mb={2}
        type="button"
      >
        Create New Job
      </Button>
    </Box>
  );
};

export default CreateJobView;
